// src/OrdenNuevoCliente.js
import React, { useState } from 'react';
import { supabase } from './supabaseClient';

const borde = '#e5e7eb';
const negro = '#111827';
const naranja = '#f97316';

async function obtenerTallerIdUsuario() {
  const { data: { user }, error } = await supabase.auth.getUser();
  if (error || !user) throw new Error('No se pudo obtener el usuario.');
  const { data, error: e2 } = await supabase
    .from('usuarios')
    .select('taller_id')
    .eq('auth_user_id', user.id)
    .single();
  if (e2 || !data?.taller_id) throw new Error('Falta taller_id en usuarios.');
  return data.taller_id;
}

const inputStyle = {
  display: 'block',
  width: '100%',
  padding: '6px 8px',
  borderRadius: 8,
  border: `1px solid ${borde}`,
  marginBottom: 6,
  fontSize: 14,
};

const labelStyle = {
  fontWeight: 600,
  marginTop: 8,
  marginBottom: 4,
  fontSize: 14,
};

export default function OrdenNuevoCliente() {
  const [cliente, setCliente] = useState({ nombre: '', telefono: '', email: '' });
  const [vehiculo, setVehiculo] = useState({
    patente: '', marca: '', modelo: '', anio: '', vin: '',
  });
  const [orden, setOrden] = useState({
    descripcion_falla: '',
    observaciones: '',
    estado: 'pendiente',
    fecha_ingreso: '',
    fecha_entrega: '',
    monto: '',
  });
  const [mensaje, setMensaje] = useState('');
  const [cargando, setCargando] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMensaje('');
    setCargando(true);
    try {
      if (!cliente.nombre) throw new Error('Ingresa el nombre del cliente.');
      if (!orden.descripcion_falla) throw new Error('Ingresa la falla.');

      const tallerId = await obtenerTallerIdUsuario();

      // Cliente
      const { data: cData, error: cErr } = await supabase
        .from('clientes')
        .insert({
          taller_id: tallerId,
          nombre: cliente.nombre,
          telefono: cliente.telefono || null,
          email: cliente.email || null,
        })
        .select('id')
        .single();
      if (cErr) throw new Error('Error cliente: ' + cErr.message);

      // Vehículo
      const { data: vData, error: vErr } = await supabase
        .from('vehiculos')
        .insert({
          taller_id: tallerId,
          cliente_id: cData.id,
          patente: vehiculo.patente || null,
          marca: vehiculo.marca || null,
          modelo: vehiculo.modelo || null,
          anio: vehiculo.anio ? parseInt(vehiculo.anio, 10) : null,
          vin: vehiculo.vin || null,
        })
        .select('id')
        .single();
      if (vErr) throw new Error('Error vehículo: ' + vErr.message);

      // Orden
      const { error: oErr } = await supabase.from('ordenes_trabajo').insert({
        taller_id: tallerId,
        cliente_id: cData.id,
        vehiculo_id: vData.id,
        descripcion_falla: orden.descripcion_falla,
        observaciones: orden.observaciones || null,
        estado: orden.estado || 'pendiente',
        fecha_ingreso: orden.fecha_ingreso || new Date().toISOString(),
        fecha_entrega: orden.fecha_entrega || null,
        monto: orden.monto ? Number(orden.monto) : null,
      });
      if (oErr) throw new Error('Error orden: ' + oErr.message);

      setMensaje('Cliente, vehículo y orden creados.');
      setCliente({ nombre: '', telefono: '', email: '' });
      setVehiculo({ patente: '', marca: '', modelo: '', anio: '', vin: '' });
      setOrden({
        descripcion_falla: '',
        observaciones: '',
        estado: 'pendiente',
        fecha_ingreso: '',
        fecha_entrega: '',
        monto: '',
      });
    } catch (err) {
      setMensaje(err.message);
    } finally {
      setCargando(false);
    }
  };

  return (
    <section>
      <h2 style={{ marginTop: 0, marginBottom: 12, color: negro }}>
        Nuevo cliente + orden
      </h2>
      <form onSubmit={handleSubmit}>
        {/* Cliente */}
        <h3 style={{ marginBottom: 4, color: negro }}>Cliente</h3>
        <label style={labelStyle}>Nombre</label>
        <input
          style={inputStyle}
          placeholder="Nombre"
          value={cliente.nombre}
          onChange={(e) => setCliente({ ...cliente, nombre: e.target.value })}
        />
        <label style={labelStyle}>Teléfono</label>
        <input
          style={inputStyle}
          placeholder="Teléfono"
          value={cliente.telefono}
          onChange={(e) => setCliente({ ...cliente, telefono: e.target.value })}
        />
        <label style={labelStyle}>Correo</label>
        <input
          style={inputStyle}
          placeholder="Correo"
          value={cliente.email}
          onChange={(e) => setCliente({ ...cliente, email: e.target.value })}
        />

        {/* Vehículo */}
        <h3 style={{ marginTop: 16, marginBottom: 4, color: negro }}>Vehículo</h3>
        <label style={labelStyle}>Patente</label>
        <input
          style={inputStyle}
          placeholder="Patente"
          value={vehiculo.patente}
          onChange={(e) => setVehiculo({ ...vehiculo, patente: e.target.value })}
        />
        <label style={labelStyle}>Marca</label>
        <input
          style={inputStyle}
          placeholder="Marca"
          value={vehiculo.marca}
          onChange={(e) => setVehiculo({ ...vehiculo, marca: e.target.value })}
        />
        <label style={labelStyle}>Modelo</label>
        <input
          style={inputStyle}
          placeholder="Modelo"
          value={vehiculo.modelo}
          onChange={(e) => setVehiculo({ ...vehiculo, modelo: e.target.value })}
        />
        <label style={labelStyle}>Año</label>
        <input
          style={inputStyle}
          type="number"
          placeholder="Año"
          value={vehiculo.anio}
          onChange={(e) => setVehiculo({ ...vehiculo, anio: e.target.value })}
        />
        <label style={labelStyle}>VIN</label>
        <input
          style={inputStyle}
          placeholder="VIN"
          value={vehiculo.vin}
          onChange={(e) => setVehiculo({ ...vehiculo, vin: e.target.value })}
        />

        {/* Orden */}
        <h3 style={{ marginTop: 16, marginBottom: 4, color: negro }}>Orden</h3>
        <label style={labelStyle}>Descripción de la falla</label>
        <textarea
          style={{ ...inputStyle, minHeight: 60, resize: 'vertical' }}
          placeholder="Descripción de la falla"
          value={orden.descripcion_falla}
          onChange={(e) =>
            setOrden({ ...orden, descripcion_falla: e.target.value })
          }
        />
        <label style={labelStyle}>Observaciones</label>
        <textarea
          style={{ ...inputStyle, minHeight: 40, resize: 'vertical' }}
          placeholder="Observaciones"
          value={orden.observaciones}
          onChange={(e) =>
            setOrden({ ...orden, observaciones: e.target.value })
          }
        />

        <label style={labelStyle}>Monto (CLP)</label>
        <input
          style={inputStyle}
          type="number"
          min="0"
          placeholder="Ej: 50000"
          value={orden.monto}
          onChange={(e) =>
            setOrden({ ...orden, monto: e.target.value })
          }
        />

        <button
          type="submit"
          disabled={cargando}
          style={{
            marginTop: 12,
            padding: '8px 14px',
            borderRadius: 999,
            border: 'none',
            backgroundColor: naranja,
            color: 'white',
            cursor: 'pointer',
            fontWeight: 600,
          }}
        >
          {cargando ? 'Guardando...' : 'Crear cliente + orden'}
        </button>
      </form>
      {mensaje && <p style={{ marginTop: 10 }}>{mensaje}</p>}
    </section>
  );
}
